import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { combineLatest, filter, map, take } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { APP_ROUTES } from '@core/constants/route.constant';

export const authGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return combineLatest([authService.session$, authService.userProfile$]).pipe(
    filter(([session, profile]) => session !== undefined && profile !== undefined),
    take(1),
    map(([session, profile]) =>
      session && profile
        ? true
        : router.createUrlTree([APP_ROUTES.AUTH.ROOT, APP_ROUTES.AUTH.LOGIN]),
    ),
  );
};
